import CButton from 'app/components/Common/CButton'
import CDivider from 'app/components/Common/CDivider'
import CText from 'app/components/Common/CText'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { COLORS, FONTS } from 'app/constants/STYLES'
import { NAME } from 'app/constants/APIKEYS'
import {
	FooterContainer,
	FooterWrapper,
	Copyright,
	CopyrightText,
	PrivacyBtn,
} from './styles'
import { useWindowDimensions } from 'app/hooks'

const Footer = () => {
	const { width } = useWindowDimensions()
	const mobile = width < 600
	const { t } = useTranslation()
	const navigate = useHistory()
	const goTo = (url: any) => {
		navigate.push(url)
	}

	// 동적 브랜드명과 현재 연도로 저작권 텍스트 생성
	const getDynamicCopyright = () => {
		try {
			const brandConfig = (window as any).BRAND_CONFIG || {}
			const brandName = brandConfig.REACT_APP_NAME || NAME || 'GLOBALBIT'
			const currentYear = new Date().getFullYear()
			return ` Copyright © ${brandName} ASSET ${currentYear}`
		} catch {
			// 폴백: 기존 번역 사용
			return t('copyRight')
		}
	}

	return (
		<FooterContainer>
			<FooterWrapper>
				<Copyright>
					<CopyrightText>
						<CText
							text={getDynamicCopyright()}
							style={{
								...FONTS.h5,
								fontSize: 14,
								fontWeight: '500',
							}}
						/>
					</CopyrightText>
				</Copyright>
			</FooterWrapper>
		</FooterContainer>
	)
}

export default React.memo(Footer)
